import portalStore from './ClaimPortal/store';
import websiteStore from './ClaimWebsite/store';

export const ClaimWebsiteStore = websiteStore;
export const ClaimPortalStore = portalStore;
